exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorDiv {\n  margin-bottom: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/app/shared/campo-control-erro/campo-control-erro.component.scss
// module id = ../../../../../src/app/shared/campo-control-erro/campo-control-erro.component.scss
// module chunks = main